import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContactUsComponent } from './components/contact-us/components/contact-us/contact-us.component';
import { LandingIndexComponent } from './components/landing-index/landing-index.component';
import { LandingComponent } from './components/landing/landing.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { PricingDetailsComponent } from './components/pricing-details/pricing-details.component';
import { UnauthorisedPageComponent } from './components/unauthorised-page/unauthorised-page.component';
import { LoginActivateGuard } from './guards/login-activate.guard';
import { LoginDeactivateGuard } from './guards/login-deactivate.guard';
import { HomeComponent } from './Modules/home/components/home/home.component';
import { IdmsComponent } from './Modules/idms/components/idms/idms.component';
import { InformateComponent } from './Modules/informate/components/informate/informate.component';
import { ManagementComponent } from './Modules/management/components/management/management.component';
import { SettingsIndexComponent } from './Modules/settings/components';
import { CdmsComponent } from './Modules/cdms/components/cdms/cdms.component';

const routes: Routes = [
    { path: 'home', component: HomeComponent, canActivate: [LoginActivateGuard] },
    {
        path: 'landing',
        component: LandingIndexComponent,
        canActivate: [LoginDeactivateGuard],
        children: [
            { path: '', component: LandingComponent },
            { path: 'contactUs', component: ContactUsComponent },
            { path: 'pricing', component: PricingDetailsComponent },
        ],
    },
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    { path: '401', component: UnauthorisedPageComponent },
    { path: '404', component: PageNotFoundComponent },
    { path: 'contact-us', component: ContactUsComponent },
    { path: 'pricing', component: PricingDetailsComponent },
    {
        path: 'informate',
        component: InformateComponent,
        loadChildren: () => import('./Modules/informate/informate.module').then((m) => m.InformateModule),
    },
    {
        path: 'management',
        component: ManagementComponent,
        loadChildren: () => import('./Modules/management/management.module').then((m) => m.ManagementModule),
    },
    {
        path: 'settings',
        component: SettingsIndexComponent,
        loadChildren: () => import('./Modules/settings/settings.module').then((m) => m.SettingsModule),
    },
    {
        path: 'idms',
        component: IdmsComponent,
        loadChildren: () => import('./Modules/idms/idms.module').then((m) => m.IdmsModule),
    },
    {
        path: 'cdms',
        component: CdmsComponent,
        loadChildren: () => import('./Modules/cdms/cdms.module').then((m) => m.CdmsModule),
    },
    // {
    //   path: "plant-manager",
    //   loadChildren: () =>
    //     import("./Modules/idms/idms.module").then(
    //       // (m) => m.IdmsModule
    //     )
    // },
    { path: '**', redirectTo: '/404', pathMatch: 'full' },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            useHash: false,
            enableTracing: false,
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
